<md-subheader-tabs
  data-test="c630TCVz"
  [handleClick]="true"
  (tabChange)="onTabChange($event)"
  style="margin-left: 8px; display: block"
>
  <md-subheader-tab
    data-test="3tRLNw3_"
    *ngFor="let entry of tabEntries; trackBy: trackIndex"
    [id]="entry[0]"
    data-activeId="currentTab"
  >
    {{ entry[1] }}
  </md-subheader-tab>
</md-subheader-tabs>
<div data-test="d8rwHORE" class="tabs_bb"></div>
